import styled from '@emotion/styled';
import React from 'react';
import { colors } from '../../constants/theme';
import IconSvg from '../common/IconSvg';

export const TutorialContainer = styled.div`
  left: -50vw;
  top: -50vh;
  position: relative;
  pointer-events: none;
`;

export const HighlightZone = styled.div`
  position: absolute;
  pointer-events: none;
  width: ${props => props.width};
  height: ${props => props.height};
  top: ${props => props.top};
  left: ${props => props.left};
`;

const Button = styled.span`
  padding: 0 0.8em;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 2px;
`;

const PopoverContainer = styled.div`
  &>div{
    margin-right: 16px;
    color: ${colors.whiteBackground }
  }
`;

export const PopoverContent = props => (
  <PopoverContainer>
    <div>{props.content}</div>
    <Button onClick={e=>props.onClick(e)}>
      <IconSvg size={10} type="exit-white" />
    </Button>
  </PopoverContainer>
);

const ClickBlockingDiv = styled.div`
  position: absolute;
  pointer-events: auto;
  top: ${props => props.top};
  left: ${props => props.left};
  height: ${props => props.height};
  width: ${props => props.width};
  background-color: rgba(0,0,0,${props => props.opacity});
`;

export const ClickBlockingFrame = props => {
  const div1 = {
    width: `${props.left}px`,
    height: '100vh',
    top: 0,
    left: 0
  };
  const div2 = {
    width: `${props.width}px`,
    height: `${props.top}px`,
    top: 0,
    left: `${props.left}px`
  };
  const div3 = {
    width: `${props.width}px`,
    height: `calc(100vh - ${props.height + props.top}px)`,
    top: `${props.height + props.top}px`,
    left: `${props.left}px`
  };
  const div4 = {
    width: `calc(100vw - ${props.left + props.width}px)`,
    height: '100vh',
    top: 0,
    left: `${props.left + props.width}px`,
  };

  return (
    <React.Fragment>
      <ClickBlockingDiv {...div1} opacity={props.opacity} />
      <ClickBlockingDiv {...div2} opacity={props.opacity} />
      <ClickBlockingDiv {...div3} opacity={props.opacity} />
      <ClickBlockingDiv {...div4} opacity={props.opacity} />
    </React.Fragment>
  );
}
